// assets/cart-drawer.js

class CartDrawer {
  constructor() {
    this.drawer = document.getElementById('cart-drawer');
    this.overlay = this.drawer.querySelector('.cart-drawer__overlay');
    this.closeBtn = this.drawer.querySelector('.cart-drawer__close');
    this.contentContainer = this.drawer.querySelector('.cart-drawer__content');
    this.subtotalElement = this.drawer.querySelector('.cart-drawer__subtotal-price');
    this.checkoutBtn = this.drawer.querySelector('.cart-drawer__checkout');
    this.upsellContainer = this.drawer.querySelector('.cart-drawer__upsell');
    this.upsellProducts = this.drawer.querySelector('.cart-drawer__upsell-products');
    
    this.freeShippingThreshold = 39.90; // Seuil pour livraison gratuite à 39.90€
    this.recentlyViewedProducts = this.getRecentlyViewed(); // Récupérer les produits vus récemment
    
    this.init();
  }
  
  init() {
    // Event listeners
    this.closeBtn.addEventListener('click', () => this.close());
    this.overlay.addEventListener('click', () => this.close());
    
    // Swipe pour fermer sur mobile
if (window.innerWidth <= 480) {
  let startX = 0;
  const container = this.drawer.querySelector('.cart-drawer__container');
  
  container.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
  });
  
  container.addEventListener('touchend', (e) => {
    const endX = e.changedTouches[0].clientX;
    const diff = endX - startX;
    
    // Si swipe de plus de 100px vers la droite, fermer
    if (diff > 100) {
      this.close();
    }
  });
}

    // Gérer le clic sur le bouton checkout
this.checkoutBtn.addEventListener('click', () => {
  window.location.href = '/checkout';
});

    // Gérer les clics sur le bouton panier dans le header
    document.querySelectorAll('.js-drawer-open-cart').forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    });
    
    // Écouter les clics sur les boutons "Ajouter au panier"
document.addEventListener('click', (e) => {
  // Vérifier si c'est un bouton d'ajout au panier ou un submit de formulaire
  const addToCartBtn = e.target.closest('[data-add-to-cart], .add-to-cart, .product-form__submit, button[name="add"], input[type="submit"][name="add"]');
  
  if (addToCartBtn) {
    const form = addToCartBtn.closest('form[action*="/cart/add"]');
    if (form) {
      e.preventDefault();
      this.addToCart(form);
    }
  }
});

// Gérer le submit des formulaires d'ajout au panier
document.addEventListener('submit', (e) => {
  if (e.target.matches('form[action*="/cart/add"]')) {
    e.preventDefault();
    this.addToCart(e.target);
  }
});
    
    // Délégation d'événements pour les actions du cart drawer
    this.contentContainer.addEventListener('click', (e) => {
      if (e.target.closest('.cart-item__quantity-btn')) {
        const btn = e.target.closest('.cart-item__quantity-btn');
        const action = btn.dataset.action;
        const itemKey = btn.dataset.key;
        
        if (action === 'increase') {
          this.updateQuantity(itemKey, 1);
        } else if (action === 'decrease') {
          this.updateQuantity(itemKey, -1);
        }
      }
      
      if (e.target.matches('.cart-item__remove')) {
        const itemKey = e.target.dataset.key;
        this.removeItem(itemKey);
      }
    });
    
    // Gérer les clics sur les produits upsell
    this.upsellContainer.addEventListener('click', (e) => {
      if (e.target.matches('.upsell-product__add')) {
        const variantId = e.target.dataset.variantId;
        this.addUpsellToCart(variantId);
      }
    });
    
    // Charger le panier au chargement de la page
    this.refreshCart();
  }
  
  open() {
    this.drawer.classList.add('cart-drawer--active');
    document.body.style.overflow = 'hidden';
    this.refreshCart();
    this.loadUpsellProducts();
  }
  
  close() {
    this.drawer.classList.remove('cart-drawer--active');
    document.body.style.overflow = '';
  }
  
  async updateQuantity(key, change) {
    const currentItem = document.querySelector(`[data-key="${key}"]`);
    const quantityElement = currentItem.querySelector('.cart-item__quantity-value');
    const currentQuantity = parseInt(quantityElement.textContent);
    const newQuantity = currentQuantity + change;
    
    // Si on descend à 0, supprimer l'article automatiquement
    if (newQuantity < 1) {
      this.removeItem(key);
      return;
    }
    
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: key,
          quantity: newQuantity
        })
      });
      
      if (response.ok) {
        this.refreshCart();
        this.updateCartCount();
      }
    } catch (error) {
      console.error('Erreur:', error);
    }
  }
  
  async removeItem(key) {
    // Ajouter une animation de suppression
    const item = document.querySelector(`[data-key="${key}"]`);
    if (item) {
      item.style.opacity = '0.5';
    }
    
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: key,
          quantity: 0
        })
      });
      
      if (response.ok) {
        this.refreshCart();
        this.updateCartCount();
      }
    } catch (error) {
      console.error('Erreur:', error);
    }
  }
  
  renderCart(cart) {
    if (cart.item_count === 0) {
      this.contentContainer.innerHTML = `
        <div class="cart-drawer__empty">
          <svg class="cart-drawer__empty-icon" viewBox="0 0 24 24">
            <path fill="currentColor" d="M17,18A2,2 0 0,1 19,20A2,2 0 0,1 17,22C15.89,22 15,21.1 15,20C15,18.89 15.89,18 17,18M1,2H4.27L5.21,4H20A1,1 0 0,1 21,5C21,5.17 20.95,5.34 20.88,5.5L17.3,11.97C16.96,12.58 16.3,13 15.55,13H8.1L7.2,14.63L7.17,14.75A0.25,0.25 0 0,0 7.42,15H19V17H7C5.89,17 5,16.1 5,15C5,14.65 5.09,14.32 5.24,14.04L6.6,11.59L3,4H1V2M7,18A2,2 0 0,1 9,20A2,2 0 0,1 7,22C5.89,22 5,21.1 5,20C5,18.89 5.89,18 7,18M16,11L18.78,6H6.14L8.5,11H16Z"/>
          </svg>
          <p class="cart-drawer__empty-text">Votre panier est vide</p>
          <a href="/collections/all" class="btn">Continuer vos achats</a>
        </div>
      `;
      this.checkoutBtn.disabled = true;
      this.upsellContainer.style.display = 'none';
    } else {
      let itemsHtml = '';
      
      cart.items.forEach(item => {
        const price = (item.final_price / 100).toFixed(2);
        const imageUrl = item.image ? item.image.replace(/(\.[^.]*)$/, '_90x90$1') : '';
        
        itemsHtml += `
          <div class="cart-item" data-key="${item.key}">
            <button class="cart-item__remove" data-key="${item.key}">Supprimer</button>
            <img src="${imageUrl}" alt="${item.product_title}" class="cart-item__image" loading="lazy">
            <div class="cart-item__details">
              <a href="${item.url}" class="cart-item__title">${item.product_title}</a>
              ${item.variant_title ? `<div class="cart-item__variants">${item.variant_title}</div>` : ''}
              <div class="cart-item__bottom">
                <div class="cart-item__quantity">
                  <button class="cart-item__quantity-btn" data-action="decrease" data-key="${item.key}">
                    −
                  </button>
                  <span class="cart-item__quantity-value">${item.quantity}</span>
                  <button class="cart-item__quantity-btn" data-action="increase" data-key="${item.key}">
                    +
                  </button>
                </div>
                <div class="cart-item__price">€${price}</div>
              </div>
            </div>
          </div>
        `;
      });
      
      this.contentContainer.innerHTML = itemsHtml;
      this.checkoutBtn.disabled = false;
      this.upsellContainer.style.display = 'block';
    }
    
    // Mettre à jour le sous-total
    const subtotal = (cart.total_price / 100).toFixed(2);
    this.subtotalElement.textContent = `€${subtotal}`;
    
    // Mettre à jour la barre de livraison gratuite
    this.updateFreeShipping(cart);
  }
  
 updateFreeShipping(cart) {
  const subtotal = cart.total_price / 100;
  const threshold = this.freeShippingThreshold;
  const progressBar = this.drawer.querySelector('.free-shipping-bar__progress');
  const messageElement = this.drawer.querySelector('.free-shipping-bar__message');
  const freeShippingContainer = this.drawer.querySelector('.cart-drawer__free-shipping');
  
  if (subtotal >= threshold) {
    progressBar.style.width = '100%';
    progressBar.style.backgroundColor = '#4CAF50';
    messageElement.textContent = '✓ Livraison gratuite débloquée!';
    messageElement.style.color = '#4CAF50';
    freeShippingContainer.style.backgroundColor = '#f0fdf4';
  } else {
    const remaining = threshold - subtotal;
    const progress = (subtotal / threshold) * 100;
    progressBar.style.width = `${progress}%`;
    progressBar.style.backgroundColor = '#333';
    messageElement.textContent = `Plus que €${remaining.toFixed(2)} pour la livraison gratuite`;
    messageElement.style.color = '#666';
    freeShippingContainer.style.backgroundColor = '#f8f8f8';
  }
}
  
  async loadUpsellProducts() {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart.js');
      const cart = await response.json();
      
      if (cart.items.length === 0) {
        this.upsellContainer.style.display = 'none';
        return;
      }
      
      // Récupérer les IDs des produits dans le panier
      const cartProductIds = cart.items.map(item => item.product_id);
      
      // Méthode 1 : Utiliser l'API de recommandations Shopify (si disponible)
      try {
        const recommendationsResponse = await fetch(window.Shopify.routes.root + `recommendations/products.json?product_id=${cartProductIds[0]}&limit=4`);
        if (recommendationsResponse.ok) {
          const recommendations = await recommendationsResponse.json();
          this.renderUpsellProducts(recommendations.products);
          return;
        }
      } catch (error) {
        console.log('API recommandations non disponible, utilisation de la méthode alternative');
      }
      
      // Méthode 2 : Utiliser les produits récemment vus
      if (this.recentlyViewedProducts.length > 0) {
        const filteredRecent = this.recentlyViewedProducts.filter(p => 
          !cartProductIds.includes(p.id) && p.available
        ).slice(0, 4);
        
        if (filteredRecent.length > 0) {
          this.renderUpsellProducts(filteredRecent);
          return;
        }
      }
      
      // Méthode 3 : Récupérer des produits de la même collection
      const firstItem = cart.items[0];
      if (firstItem.product_id) {
        try {
          // Récupérer le produit complet pour avoir ses collections
          const productResponse = await fetch(`/products/${firstItem.handle}.js`);
          const product = await productResponse.json();
          
          if (product.collections && product.collections.length > 0) {
            const collectionHandle = product.collections[0].handle;
            const collectionResponse = await fetch(`/collections/${collectionHandle}/products.json?limit=6`);
            const collection = await collectionResponse.json();
            
            // Filtrer pour exclure les produits déjà dans le panier
            const filteredProducts = collection.products.filter(p => 
              !cartProductIds.includes(p.id) && p.available
            ).slice(0, 4);
            
            this.renderUpsellProducts(filteredProducts);
            return;
          }
        } catch (error) {
          console.log('Erreur chargement collection:', error);
        }
      }
      
      // Méthode 4 : Produits best-sellers comme fallback final
      try {
        const bestSellersResponse = await fetch('/collections/best-sellers/products.json?limit=4');
        if (bestSellersResponse.ok) {
          const bestSellers = await bestSellersResponse.json();
          const filteredBestSellers = bestSellers.products.filter(p => 
            !cartProductIds.includes(p.id) && p.available
          );
          this.renderUpsellProducts(filteredBestSellers);
        }
      } catch (error) {
        console.log('Collection best-sellers non trouvée');
        this.upsellContainer.style.display = 'none';
      }
      
    } catch (error) {
      console.error('Erreur chargement recommandations:', error);
      this.upsellContainer.style.display = 'none';
    }
  }
  
  renderUpsellProducts(products) {
    if (!products || products.length === 0) {
      this.upsellContainer.style.display = 'none';
      return;
    }
    
    let upsellHtml = '';
    products.forEach(product => {
      if (product.available) {
        const price = (product.price / 100).toFixed(2);
        const imageUrl = product.featured_image || product.images[0];
        const imageUrlSized = imageUrl.replace(/(\.[^.]*)$/, '_120x120$1');
        
        upsellHtml += `
          <div class="upsell-product">
            <img src="${imageUrlSized}" alt="${product.title}" class="upsell-product__image" loading="lazy">
            <div class="upsell-product__title">${product.title}</div>
            <div class="upsell-product__price">€${price}</div>
            <button class="upsell-product__add" data-variant-id="${product.variants[0].id}">
              Ajouter
            </button>
          </div>
        `;
      }
    });
    
    if (upsellHtml) {
      this.upsellProducts.innerHTML = upsellHtml;
      this.upsellContainer.style.display = 'block';
    } else {
      this.upsellContainer.style.display = 'none';
    }
  }
  
  async addUpsellToCart(variantId) {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      });
      
      if (response.ok) {
        this.refreshCart();
        this.updateCartCount();
        // Petit feedback visuel
        const btn = document.querySelector(`[data-variant-id="${variantId}"]`);
        if (btn) {
          btn.textContent = 'Ajouté!';
          setTimeout(() => {
            btn.textContent = 'Ajouter';
          }, 1500);
        }
      }
    } catch (error) {
      console.error('Erreur ajout upsell:', error);
    }
  }
  
  // Reste des méthodes inchangées...
  async addToCart(form) {
    const formData = new FormData(form);
    formData.append('sections', 'cart-drawer');
    
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData
      });
      
      if (response.ok) {
        this.refreshCart();
        this.open();
        this.updateCartCount();
      }
    } catch (error) {
      console.error('Erreur:', error);
    }
  }
  
  async refreshCart() {
    this.drawer.classList.add('cart-drawer--loading');
    
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart.js');
      const cart = await response.json();
      
      this.renderCart(cart);
      this.drawer.classList.remove('cart-drawer--loading');
    } catch (error) {
      console.error('Erreur:', error);
      this.drawer.classList.remove('cart-drawer--loading');
    }
  }
  
  async updateCartCount() {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart.js');
      const cart = await response.json();
      
      document.querySelectorAll('.cart-count, .cart-link__bubble').forEach(element => {
        element.textContent = cart.item_count;
        
        if (element.classList.contains('cart-link__bubble')) {
          if (cart.item_count > 0) {
            element.classList.add('cart-link__bubble--visible');
          } else {
            element.classList.remove('cart-link__bubble--visible');
          }
        }
      });
    } catch (error) {
      console.error('Erreur:', error);
    }
  }
  // Méthode pour récupérer les produits récemment vus
  getRecentlyViewed() {
    try {
      const stored = localStorage.getItem('recentlyViewed');
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  }
  
  // Méthode pour sauvegarder un produit vu (à appeler sur les pages produit)
  static saveRecentlyViewed(productData) {
    try {
      let recentlyViewed = localStorage.getItem('recentlyViewed');
      recentlyViewed = recentlyViewed ? JSON.parse(recentlyViewed) : [];
      
      // Retirer le produit s'il existe déjà
      recentlyViewed = recentlyViewed.filter(p => p.id !== productData.id);
      
      // Ajouter en début de liste
      recentlyViewed.unshift({
        id: productData.id,
        title: productData.title,
        handle: productData.handle,
        price: productData.price,
        featured_image: productData.featured_image,
        available: productData.available,
        variants: productData.variants
      });
      
      // Garder seulement les 10 derniers
      recentlyViewed = recentlyViewed.slice(0, 10);
      
      localStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewed));
    } catch (error) {
      console.error('Erreur sauvegarde produit vu:', error);
    }
  }
}

// Initialiser le cart drawer
document.addEventListener('DOMContentLoaded', () => {
  window.cartDrawer = new CartDrawer();
});